import React from 'react';
import { SparklesIcon, RefreshCwIcon } from 'lucide-react';
const situations = [{
  icon: SparklesIcon,
  title: 'Du startest neu mit Close',
  text: 'Du nutzt noch ein anderes System oder hast bisher gar kein CRM – und willst den Aufbau nicht selbst herausfinden müssen.'
}, {
  icon: RefreshCwIcon,
  title: 'Du hast Close – bist aber nicht zufrieden',
  text: 'Dein System wurde schon von jemandem eingerichtet, doch es hakt. Du überlegst, den Anbieter zu wechseln.'
}];
export function SituationSection() {
  return <section className="py-16 lg:py-24 bg-[#0d1225]" data-id="element-190" data-mp="1swmwn6anjoez">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191" data-mp="1e0x8p2lwp17m">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16" data-id="element-192" data-mp="1e2i6d13ip09p">
          <div className="lg:col-span-5" data-id="element-193" data-mp="1ixnorpxpnwt1">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-5" data-id="element-194" data-mp="2kywipvflz26">
              Close CRM neu einführen oder Agentur wechseln?
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-10" data-id="element-195" data-mp="7lmvbxpwjk6y">
              In beiden Fällen gilt: Dein CRM ist einer der wichtigsten Faktoren
              in deinem Unternehmen. Wenn du irgendwann verkaufen willst, kann
              es sogar deinen Unternehmenswert mitbestimmen.
            </p>
            <div className="flex items-baseline gap-4" data-id="element-196" data-mp="qbae3wppdhhn">
              <span className="text-6xl lg:text-7xl font-bold text-[#ff6b35]" data-id="element-197" data-mp="lamp1gl1baq2">
                50&nbsp;%
              </span>
              <p className="text-gray-300 leading-snug" data-id="element-198" data-mp="106vj83q2ixvm">
                unserer Anfragen kommen von Teams, die Close bereits haben – oft
                nach 10.000–20.000&nbsp;€ für Setup und Betreuung bei einer
                anderen Agentur.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6" data-id="element-199" data-mp="1506injsjwcdi">
            {situations.map(s => <div key={s.title} className="flex flex-col bg-[#0a0e1a] border border-white/10 rounded-2xl p-7" data-id="element-200" data-mp="1iz664o4bul83">
                <s.icon className="w-6 h-6 text-[#ff6b35] mb-5" aria-hidden="true" data-id="element-201" data-mp="bmozrclujv2z" />
                <h3 className="text-xl font-semibold text-white mb-3" data-id="element-202" data-mp="fnhbcci6yc2f">{s.title}</h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-203" data-mp="fleep9mj9koq">{s.text}</p>
              </div>)}
            <p className="sm:col-span-2 text-gray-500 text-sm leading-relaxed" data-id="element-204" data-mp="pdk369dktjz6">
              Egal, wo du startest: Die folgenden sechs Punkte entscheiden, ob
              dein Close-System langfristig Umsatz bringt – oder Probleme macht.
            </p>
          </div>
        </div>
      </div>
    </section>;
}